export class AfterSaleBookingContext {

    public routeTo: string[] = [];
    constructor() {
    }
}